// Hash helpers (Web Crypto; works in browsers, workers and Node >= 20).

export type Bytes = Uint8Array | ArrayBuffer;

function view(b: Bytes): Uint8Array<ArrayBuffer> {
  if (b instanceof Uint8Array) return b as Uint8Array<ArrayBuffer>;
  return new Uint8Array(b);
}

export function toHex(bytes: Uint8Array): string {
  let s = '';
  for (const x of bytes) s += x.toString(16).padStart(2, '0');
  return s;
}

export function fromHex(hex: string): Uint8Array {
  if (!/^(?:[0-9a-fA-F]{2})*$/.test(hex)) throw new Error('bad hex');
  const out = new Uint8Array(hex.length / 2);
  for (let i = 0; i < out.length; i++) out[i] = parseInt(hex.slice(i * 2, i * 2 + 2), 16);
  return out;
}

export async function digest(alg: 'SHA-1' | 'SHA-256', data: Bytes): Promise<Uint8Array> {
  return new Uint8Array(await crypto.subtle.digest(alg, view(data)));
}

export async function sha256Hex(data: Bytes | string): Promise<string> {
  const b = typeof data === 'string' ? new TextEncoder().encode(data) : data;
  return toHex(await digest('SHA-256', b));
}

export async function sha1Hex(data: Bytes): Promise<string> {
  return toHex(await digest('SHA-1', data));
}
